// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.encounter.examtestlibrary.AdminUpdateWorkflowTestTemplateSvcTriggerRequest */
/* istanbul ignore next */
@GandalfModel
export class AdminUpdateWorkflowTestTemplateSvcTriggerRequest extends GandalfModelBase {

	@GandalfArray(Number)
	formFieldIds!: number[] | null;

	@GandalfValidator({ notNull: { message: 'Service Trigger is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	id!: number;

	@GandalfProperty({ designType: Number })
	serviceId!: number | null;

	@GandalfConstantDecorator(constants.TriggerRuleType)
	@GandalfValidator({ notNull: { message: 'Trigger Rule is required' } })
	@GandalfProperty({ designType: constants.TriggerRuleType, isRequired: true })
	triggerRuleType!: constants.TriggerRuleType;

}
